import { ThemeOverrides } from '@dadohr/shared/domainTypes/theme';
import { ThemeProvider } from '@emotion/react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import React, { useMemo } from 'react';
import { createEmotionTheme } from './emotionTheme';
import { createMuiTheme } from './muiTheme';

const AppThemeProviderPrivate: React.FC<{
  themeOverrides?: ThemeOverrides;
  variant?: 'ADMIN_APP' | 'EMPLOYEE_APP';
}> = ({ children, themeOverrides, variant }) => {
  const themes = useMemo(() => {
    const muiTheme = createMuiTheme((t) => {
      // need to custom merge a bit here, as color definitions don't align perfectly

      // TODO handle all colors - we only use some super basics for now, so let's stick with
      // that... Bailing out.
      if (!themeOverrides) {
        return t;
      }
      return {
        ...t,
        palette: {
          ...t.palette,
          primary: themeOverrides?.colors?.primary || t.palette.primary,
          secondary: themeOverrides?.colors?.secondary || t.palette.secondary,
          text: {
            ...t.palette.text,
            primary:
              themeOverrides?.colors?.text?.primary || t.palette.text.primary,
            secondary:
              themeOverrides?.colors?.text?.secondary ||
              t.palette.text.secondary
          }
        }
      };
    }, variant);
    const emotionTheme = createEmotionTheme(muiTheme, themeOverrides);
    return {
      mui: muiTheme,
      combined: {
        ...muiTheme,
        ...emotionTheme
      }
    };
  }, [themeOverrides, variant]);
  return (
    <MuiThemeProvider theme={themes.mui}>
      {(() => (
        <ThemeProvider theme={themes.combined}>{children}</ThemeProvider>
      ))()}
    </MuiThemeProvider>
  );
};

export const AppThemeProvider: React.FC = ({ children }) => (
  <AppThemeProviderPrivate>{children}</AppThemeProviderPrivate>
);

export const AppThemeProviderWithOptionalCustomizations: React.FC<{
  theme?: ThemeOverrides | null;
  variant?: 'ADMIN_APP' | 'EMPLOYEE_APP';
}> = React.memo(({ theme, variant, children }) => {
  return (
    <AppThemeProviderPrivate
      themeOverrides={theme || undefined}
      variant={variant}
    >
      {children}
    </AppThemeProviderPrivate>
  );
});
